import Marquee from "react-fast-marquee";
import { Asterisk } from "lucide-react";

// Big editorial statement marquee.
export const MarqueeText = ({
  items = [],
  speed = 42,
  direction = "left",
  className = "",
}) => {
  return (
    <div className={`overflow-hidden ${className}`}>
      <Marquee gradient={false} speed={speed} direction={direction}>
        {items.map((t, i) => (
          <span key={i} className="flex items-center">
            <span className="font-heading text-4xl md:text-6xl font-extrabold uppercase tracking-tight text-white/90 whitespace-nowrap px-6">
              {t}
            </span>
            <Asterisk className="h-7 w-7 md:h-10 md:w-10 text-brand-red" strokeWidth={2.5} />
          </span>
        ))}
      </Marquee>
    </div>
  );
};
